import './Style/Connection.style.css'
import { Form, Input, Button, Alert, message, Steps, InputNumber, Modal , Select  } from "antd";
import { useState } from 'react';
import axios from 'axios';
import {api} from '../helper/axios/index'
import logo from '../assets/images/Inscription.svg'
import { Link } from 'react-router-dom';
import { ArrowRightOutlined } from '@ant-design/icons';
import moment from 'moment';
import dayjs from 'dayjs';
import {useNavigate} from 'react-router-dom';



const steps = [
    {
      title: 'Personnel',
      key:1,
      fields: [
        { key: 'step1', name: 'email', label: 'Email', type: 'email' },
        { key: 'step2', name: 'first_name', label: 'Prénom', type: 'text' },
        { key: 'step3', name: 'last_name', label: 'Nom', type: 'text' },
        { key: 'step4',name: 'phone', label: 'Téléphone', type: 'tel' },
        { key: 'step5', name: 'localite', label: 'Localité', type: 'text' },
        { key: 'step6', name: 'adress', label: 'Adresse', type: 'text' },
        { key: 'step7', name: 'civiliter', label: 'civilité', type: 'select' },
        // { key: 'step14', name: 'password', label: 'password', type: 'password' },
      ],
    },
    {
      title: 'Dossier',
      key:2,
      fields: [
        { key: 'step7', name: 'businessStat', label: "Chiffre d\'affaire", type: 'number' },
        { key: 'step8', name: 'describe', label: "Description de l'entreprise", type: 'textarea' },
        { key: 'step9', name: 'locativeValue', label: 'Valeur locative', type: 'number' },
        { key: 'step10', name: 'numberEmploye', label: "Nombre d'employés", type: 'number' },
        { key: 'step11', name: 'title', label: "Nom de l'entreprise", type: 'text' },
        { key: 'step12', name: 'niu', label: 'Numéro d\'identification unique (NIU)', type: 'text' },
        { key: 'step13', name: 'dateBegin', label: 'Date de début', type: 'date' },
      ],
    },
  ];


export const Inscription = ()=>{

    const navigate = useNavigate();
    const [current, setCurrent] = useState(0);
  const [formData, setFormData] = useState({});

  

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const [form] = Form.useForm();

  const next = () => {
    form.validateFields().then(values => {
      setFormData({ ...formData, ...values });
      setCurrent(current + 1);
    }).catch(error => {
      console.error(error);
    });
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const handleAdd = async (user, folder) => {

    try {
      const contient = user.phone;
      if(contient.startsWith('+242')){
        user.phone= user.phone
      }else{
        user.phone = "+242"+user.phone
      }
      folder.numberEmploye  = parseInt(folder.numberEmploye)
      const data = {
          user: user,
          folder: folder,
        };
      const response = await api.post(ENDPOINT, data);
  
      // Traitez la réponse du serveur ici (par exemple, enregistrer le token dans les cookies ou sessionStorage).
      console.log('Réponse du serveur:', response.data);

      countDown()
      setLoading(false)
     form.resetFields()
  
    } catch (error) {
        setAfficheError(true)
        setLoading(false)
       
        // console.error(error.response.data.errors.user.errors_list
        //     );

        console.log(error.response)
            for(let i=0; i<error?.response?.data?.errors?.user?.errors_list.length; i++){
                console.log(error?.response?.data?.errors?.user?.errors_list[i]);
                message.error(error?.response?.data?.errors?.user?.errors_list[i]);
            }
            for(let i=0; i<error?.response?.data?.errors?.folder?.errors_list.length; i++){
              console.log(error?.response?.data?.errors?.folder?.errors_list[i]);
              message.error(error?.response?.data?.errors?.folder?.errors_list[i]);
          }
      setError(
      <Alert
        message={error?.response?.data?.message?.[0]}
        type="error"
        showIcon
  />)
    }
  };

  const onFinish = async () => {
   // console.log('Données du formulaire:', { ...formData, ...form.getFieldsValue() });

    // console.log("Users : " , formData);

  // const madate = form.getFieldsValue();
  setLoading(true)
   const formattedDate = moment(form.getFieldsValue().dateBegin['$d']).format('YYYY/MM/DD');

   form.getFieldsValue().dateBegin= formattedDate;   

   console.log("personnel: ",formData )
   console.log("Dossier : ", form.getFieldsValue())
   await handleAdd(formData, form.getFieldsValue());
  //  message.success('Traitement terminé !');
  };
    const ENDPOINT = "auth0/register?lang=fr";

    const [error, setError] = useState(null);
    const [afficheError, setAfficheError] = useState(false);     
    const [loading, setLoading] = useState(false);
      
    
    const [modal, contextHolder] = Modal.useModal();
    const countDown = () => {
      let secondsToGo = 60;
      const instance = modal.success({
        title: 'Votre déclaration a été soumise avec succès',
        content: `Votre compte est en cours de vérification par notre équipe. Une fois que votre compte aura été approuvé, vous recevrez vos informations de connexion par e-mail. Veuillez vérifier votre boîte de réception régulièrement. Nous vous remercions de votre patience et de votre contribution en tant que contribuable enregistré.`,
         onOk:()=>{
            setTimeout(() => {
                navigate('/connection');
            }, 500);
         }
    });

      const timer = setInterval(() => {
        secondsToGo -= 1;
        instance.update({
          content: `Votre compte est en cours de vérification par notre équipe. Une fois que votre compte aura été approuvé, vous recevrez vos informations de connexion par e-mail. Veuillez vérifier votre boîte de réception régulièrement. Nous vous remercions de votre patience et de votre contribution en tant que contribuable enregistré.`,
        });
      }, 1000);
      
      setTimeout(() => {
        clearInterval(timer);
        instance.destroy();
      }, secondsToGo * 1000);
    };

    return(
        <>


      {contextHolder}
           
           <div className="container d-flex justify-content-center align-items-center min-vh-100">
        {/*--------------------- Login Container ------------------------*/}
        <div className="row border rounded-5 p-3 bg-white shadow box-area hauteur">
          <div className="col-md-12 right-box">
            <div className="row align-items-center">
              <div className="header-text mb-4">
                <p className='text-center'>Veuillez compléter tous les champs ci-dessous pour effectuer votre déclaration et devenir contribuable.</p>
              </div>
<Steps current={current} items={items}/>

      <Form
        className='mt-3 row'
        layout="vertical"
        form={form}
       
        onFinish={current === steps.length - 1 ? onFinish : next}
      >
        
        {steps[current].fields.map((field) => (
  <div className='col-md-6' key={field.name}>
   <Form.Item
  label={field.label}
  name={field.name}
  rules={[
    { required: true, message: `Veuillez entrer votre ${field.label} !` },
    field.name === 'niu' ? { pattern: /^P/, message: 'Le NIU doit commencer par un P' } : null
  ]}
>
  {field.type === 'textarea' ? (
    <Input.TextArea rows={4} style={{ width: '100%', height: '20px', overflow: "hidden" }}  placeholder={`Entrer votre ${field.label.toLowerCase()}`} />
  ) : field.type === 'number' ? (
    <Input type='number' style={{ width: '100%' }}  placeholder={`Entrer votre ${field.label.toLowerCase()}`}/>
  ) : field.type === 'date' ? (
    <input type='date' className='form-control' name="dateBegin"  style={{ width: '100%' }} />
  ) : field.name === 'phone' ? (
    <Input
      style={{ width: '100%' }}
      placeholder={`Entrer ${field.label.toLowerCase()}`}
      addonBefore="+242"
      maxLength={13}
    />
  ) : field.type === 'select' ? (
    <Select style={{ width: '100%' }} placeholder={`Sélectionnez votre ${field.label.toLowerCase()}`}>
      <option value="Monsieur">Monsieur</option>
      <option value="Madame">Madame</option>
    </Select>
  ) : (
    <Input style={{ width: '100%' }}  placeholder={`Entrer votre ${field.label.toLowerCase()}`}/>
  )}
</Form.Item>


  </div>
))}

      

        <div style={{ marginTop: 10}} className='d-flex align-items-center justify-content-end' >
          {current > 0 && (
            <Button style={{ margin: '0 8px',width: "12em" }} onClick={prev}>
              Précédent
            </Button>
          )}
          {current < steps.length - 1 && (
            <div className='d-flex justify-content-end'>
               <Button
            icon={<ArrowRightOutlined />}
            style={{width: "12em",display: "flex", alignItems:"center", justifyContent: "center"}}
            type="primary" htmlType="submit">
              Suivant
            </Button>
            </div>
          )}
          {current === steps.length - 1 && (
            <Button 
            loading={loading}
            icon={<ArrowRightOutlined />}
           style={{width: "12em",display: "inline-flex", alignItems:"center", justifyContent: "center"}}
            type="primary" htmlType="submit">
              Soumettre
            </Button>
          )}
        </div>
      </Form>

                <div className="row text-center mt-3">
                <small>Vous avez un compte ?  <Link to="/connection"  style={{color: '#6C63FF'}}>Connection</Link></small>
              </div>
            </div>
          </div> 
        </div>
      </div>
 
        </>
    )
}